import React, { useEffect, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import trLocale from '@fullcalendar/core/locales/tr';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const CalendarView = () => {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${apiUrl}/api/appointments`)
      .then((res) => {
        const formattedEvents = res.data.map((appt) => {
          // Her randevuya özel rastgele bir kod üret (anonimlik için)
          const code = Math.random().toString(36).substring(2, 6).toUpperCase();
          return {
            title: `Randevu - ${code}`,
            start: `${appt.date}T${appt.time}`,
            allDay: false
          };
        });
        setEvents(formattedEvents);
      })
      .catch((err) => {
        console.error('Randevular alınamadı:', err);
      });
  }, []);

  const handleDateClick = (arg) => {
    const clickedDate = arg.date;
    const iso = clickedDate.toISOString();
    const date = iso.slice(0, 10);
    const time = iso.slice(11, 16);

    if (time !== '00:00') {
      navigate(`/appointment-form?date=${date}&time=${time}`);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-xl mt-10">
      <h2 className="text-2xl sm:text-3xl font-bold mb-4 text-center text-[#042b4e]">
        Randevu Takvimi
      </h2>

      <p className="text-center text-gray-700 text-sm sm:text-base mb-6 leading-relaxed">
        Aşağıdaki takvim üzerinden <strong>09:00 – 17:00</strong> saatleri arasında, uygun bir zaman dilimine tıklayarak randevu talebinde bulunabilirsiniz.
       <p> Seçilen saat için <strong>randevu formuna yönlendirilirsiniz</strong>.</p> 
       Talebiniz değerlendirildikten sonra tarafınıza bilgi verilecektir.
      </p>

      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="timeGridWeek"
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        }}
        locale="tr"
        locales={[trLocale]}
        buttonText={{
          today: 'Bugün',
          month: 'Ay',
          week: 'Hafta',
          day: 'Gün',
          list: 'Liste'
        }}
        allDayText="Tüm Gün"
        events={events}
        dateClick={handleDateClick}
        height="auto"
        slotMinTime="09:00:00"
        slotMaxTime="17:00:00"
      />
    </div>
  );
};

export default CalendarView;
